import React, { lazy } from 'react';
import { Product } from '../types/types';
import { CONFIG } from '../data/config';
import { PlusIcon } from 'lucide-react';
interface ProductCardProps {
  product: Product;
  onAdd: (product: Product) => void;
}
export function ProductCard({
  product,
  onAdd
}: ProductCardProps) {
  return <div className="bg-surface rounded-2xl shadow-sm border border-gray-800 flex flex-col h-full overflow-hidden" data-id="element-328">
      {product.image && <div className="h-28 w-full bg-surface-light relative" data-id="element-329">
          <img src={product.image} alt={product.name} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-330" />
        </div>}
      <div className="p-4 flex flex-col flex-1" data-id="element-331">
        <div className="flex-1" data-id="element-332">
          <div className="flex justify-between items-start mb-2 gap-2" data-id="element-333">
            <h3 className="font-heading font-semibold text-white text-base leading-tight tracking-wide" data-id="element-334">
              {product.name}
            </h3>
            <span className="font-semibold text-verde whitespace-nowrap text-sm" data-id="element-335">
              {CONFIG.CURRENCY_SYMBOL}
              {product.price.toLocaleString()}
            </span>
          </div>
          {product.description && <p className="text-gray-400 text-xs leading-snug mb-3 line-clamp-3" data-id="element-336">
              {product.description}
            </p>}
        </div>

        <button onClick={() => onAdd(product)} className="mt-auto w-full bg-terracota/10 text-terracota font-medium py-2.5 rounded-xl flex items-center justify-center gap-1 active:bg-terracota active:text-white transition-colors min-h-[44px] text-sm border border-terracota/20" data-id="element-337">
          {product.customizable ? <>
              Personalizar <PlusIcon className="w-4 h-4" data-id="element-338" />
            </> : <>
              Agregar <PlusIcon className="w-4 h-4" data-id="element-339" />
            </>}
        </button>
      </div>
    </div>;
}